import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=3225a55a&scoped=true&"
import script from "./Example.vue?vue&type=script&lang=js&"
export * from "./Example.vue?vue&type=script&lang=js&"
import style0 from "./Example.vue?vue&type=style&index=0&id=3225a55a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3225a55a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3225a55a')) {
      api.createRecord('3225a55a', component.options)
    } else {
      api.reload('3225a55a', component.options)
    }
    module.hot.accept("./Example.vue?vue&type=template&id=3225a55a&scoped=true&", function () {
      api.rerender('3225a55a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Calculator/Example.vue"
export default component.exports